import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

export default new ValueExpression({
  identifier: 'mitnahmen',
  label: 'Mitnahmen',
  positiveDirection: PositiveDirection.custom,
  hidden: true,
});
